export default "__VITE_ASSET__BWdiyP6I__"